import React, { useState, useEffect, useContext } from 'react';
import InputField from '../InputField';
import { MDBDropdown, MDBDropdownToggle, MDBIcon, MDBDropdownMenu, MDBDropdownItem, MDBDatepicker, MDBDateTimepicker } from 'mdb-react-ui-kit';
import Pagination from './Pagination';
import { formatDate, formatDateTime } from '../../Utilities/CommonFunctions';
import CustomDateRangePicker from '../DateRangePicker';
import { UserContext } from '../../Context/UserContext';
import { useTranslation } from "../../Context/TranslationContext";
import { escapeRegExp, formatCurrency } from '../../Common';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { SecureStorage } from '../../Utilities/StorageEncryption';

// Helper function to check if a timestamp is within the last hour
const isWithinLastHour = (timestamp) => {
  if (!timestamp) return false;
  const now = new Date();
  const loginAttemptTime = new Date(timestamp);
  const diffInMs = now - loginAttemptTime;
  const oneHourInMs = 60 * 60 * 1000;
  return diffInMs > oneHourInMs;
};

const FILTER_OPTIONS_TEXT = [
  { text: 'is equal to', value: 'IsEqualTo' },
  { text: 'starts with', value: 'StartsWith' },
  { text: 'contains', value: 'Contains' },
  { text: 'ends with', value: 'EndsWith' },
  { text: 'is different from', value: 'IsDifferentFrom' },
  { text: 'does not start with', value: 'DoesNotStartWith' },
  { text: 'does not contain', value: 'DoesNotContain' },
  { text: 'does not end with', value: 'DoesNotEndWith' },
];
const FILTER_OPTIONS_VALUE = [
  { text: 'is equal to', value: 'IsEqualTo' },
  { text: 'is different from', value: 'IsDifferentFrom' },
  { text: 'greater than', value: 'GreaterThan' },
  { text: 'greater than or equal to', value: 'GreaterThanOrEqual' },
  { text: 'less than', value: 'LessThan' },
  { text: 'less than or equal to', value: 'LessThanOrEqual' },
  { text: 'between', value: 'between' },
];

const DataTable = ({ data, onPageChange, onSort, onSearch , onRowsPerPageChange, portal, search, toggleButton }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage , setRowsPerPage] = useState(10);//env 
  const [searchTerms, setSearchTerms] = useState({});
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');
  const [filters, setFilters] = useState({});
  const [dateValues, setDateValues] = useState({});
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [resetDateRange, SetResetDateRange] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const { user } = useContext(UserContext);
  const domain = SecureStorage.getItem('domain');
  const { translations } = useTranslation();

  console.log("portal", portal)

  
  const handleDatesChange = (startDate, endDate, fieldName) => {

    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);
    handleSearchDropDown(startDate+' '+endDate, fieldName)
  };
  const splitStringByLength = (str, length=30) => {
    if(str === null || str.length < 0) {
      return str;
    }
    let result = '';
    for (let i = 0; i < str.length; i += length) {
        result += str.substring(i, i + length) + '\n';
    }
    return result;
  }

  console.log("test data", data)

  const totalRecords = data.totalRecords;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const indexOfLastItem = currentPage * rowsPerPage;
  const indexOfFirstItem = Math.max(indexOfLastItem - rowsPerPage, 0);

  const [sortDirections, setSortDirections] = useState(() => {
    const initialSortDirections = {};
    data.columns.forEach((column) => {
      if (column.sort) {
        initialSortDirections[column.fieldName] = 'asc';
      }
    });
    return initialSortDirections;
  });
  const [cookieVal, setCookieVal] = useState(false);

  const cookieName = `${escapeRegExp(`${user.name}-${domain}-${portal}`)}-selectedColumns`;
  useEffect(() => {
    if (Object.keys(filters).length === 0) {
      setFilters(() => {
        const initialFilters = {};
        data.columns.forEach((column) => {
          if (column?.filter?.filterType == "Text") {
            initialFilters[column.fieldName] = { type: 'Contains', text: '' };
          } 
          else if (column?.filter?.filterType === 'List') {
            initialFilters[column.fieldName] = { type: 'ListValue', text: '' };
          }
          else {
            initialFilters[column.fieldName] = { type: 'IsEqualTo', text: '' };
          }
        });
        return initialFilters;
      });
    }
    const cookieValue = document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${escapeRegExp(cookieName)}\\s*=\\s*([^;]*).*$)|^.*$`), "$1");
    const cookieExists = document.cookie.indexOf(`${escapeRegExp(cookieName)}=`) !== -1;
    if (cookieExists ) {
      const decodedCookieValue = decodeURIComponent(cookieValue);
      const selectedColumnsArray = JSON.parse(decodedCookieValue);
      setSelectedColumns(selectedColumnsArray);
      setCookieVal(true)
    }
  }, [data, document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${escapeRegExp(cookieName)}\\s*=\\s*([^;]*).*$)|^.*$`), "$1")]);


  const handleSort = (key) => {
    const newSortDirections = [];
    newSortDirections[key] = sortDirections[key] === 'asc' ? 'desc' : 'asc';

    setSortKey(key);
    setSortDirections(newSortDirections);

    onSort(key, newSortDirections[key]);
    setCurrentPage(1);
  };

  useEffect(()=> {
    setCurrentPage(1);
  }, [toggleButton]);

  const sortedItems = () => {
    if (sortKey) {
      return [...data.rows.slice(indexOfFirstItem, indexOfLastItem)].sort((a, b) => {
        const aValue = a[sortKey].toString().toLowerCase();
        const bValue = b[sortKey].toString().toLowerCase();
        const comparison = aValue.localeCompare(bValue);
        return sortOrder === 'asc' ? comparison : -comparison;
      });
    }
    return data.rows.slice(indexOfFirstItem, indexOfLastItem);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    onPageChange(pageNumber);
  };

  const handleRowsPerPageChange = (size) => {
    setCurrentPage(1);
    setRowsPerPage(size);
    onRowsPerPageChange(size);
    onPageChange(1);
  };

  const [textValues, setTextValues] = useState([]);

  const handleSearch = (event, column, type) => {
    const phoneRegex = /^[\d\s\-\+\(\)]+$/;
    const currencyRegex = /^[\d.]+$/;
    const inputRegex = /^[a-zA-Z0-9._%+-@ ]+$/;
    const emailRegex =  /^[a-zA-Z0-9._+-@;]+$/;

    const inputText = event.target.value || event.value;
    if (inputText != undefined && inputText.length > 22 ) {
      return '';
    }
    if (inputText != undefined) {
      if (
        (type == "Phone" && !phoneRegex.test(inputText)) ||
        (type == "Currency" && !currencyRegex.test(inputText)) ||
        (type == "Email" && !emailRegex.test(inputText)) ||
        (type == "Text" && !inputRegex.test(inputText))
      ) {
        return '';
      }      
    }
    setTextValues(prevState => ({
      ...prevState,
      [column]: inputText,
    }));

    setSearchTerms((prevSearchTerms) => {
      const newSearchTerms = { ...prevSearchTerms, [column]: inputText };
      setCurrentPage(1);
      const allSearchValues = Object.entries(newSearchTerms).map(([col, filterValue]) => {
        let columnName = col;
        let secondSearch = false;
        if (col.includes("_second")) {
          columnName = col.replace("_second", "");
          secondSearch = true;
        }
        let modifiedFilterValue = filterValue;
        if (filters[columnName].type === 'ListValue' && filterValue === 'All') {
          modifiedFilterValue = '';
        }
        return {
          filter: filters[columnName].type == 'between' ? (secondSearch != true ? "GreaterThanOrEqual" : "LessThanOrEqual" ) : filters[columnName].type,
          filterValue:modifiedFilterValue,
          filterColumn: columnName,
        };
      });      
      onSearch(allSearchValues);
      return newSearchTerms;
    });
  };

  const handleSearchDropDown = (value, column) => {
    setSearchTerms((prevSearchTerms) => {
      const newSearchTerms = { ...prevSearchTerms, [column]: value != '' ? value : 'All' };
      setCurrentPage(1);
      const allSearchValues = Object.entries(newSearchTerms).map(([col, filterValue]) => {
        let columnName = col;
        let secondSearch = false;
        if (col.includes("_second")) {
          secondSearch = true;
          columnName = col.replace("_second", "");
        }
        let modifiedFilterValue = filterValue;
        if (filters[columnName].type === 'ListValue' && filterValue === 'All') {
          modifiedFilterValue = '';
        }
        return {
          filter: filters[columnName].type == 'between' ? (secondSearch != true ? "GreaterThanOrEqual" : "LessThanOrEqual" ) : filters[columnName].type,
          filterValue: modifiedFilterValue,
          filterColumn: columnName,
        };
      });

      onSearch(allSearchValues);

      return newSearchTerms;
    });
  };
  function dateOnKeyPress(e,column){
    let input = e.target;
    if(e.charCode < 47 || e.charCode > 57) {
      e.preventDefault();
    }
    let len = input.value.length;
    if(len !== 1 || len !== 3) {
      if(e.charCode == 47) {
        e.preventDefault();
      }
    }
    if(len === 2) {
      if(input.value>12){
        input.value=12;
      }
      input.value += '/';
    }
    if(len === 5) {
      input.value += '/';
    }
    if(len >= 10) {
      e.preventDefault();
      return false;
    }
  };
  function dateOnKeyDown(evt,column){
    if (evt.key === 'Backspace' || evt.key === 'Delete') {
      let input = evt.target;
      let back_len = input.value.length;
      if(back_len <= 1 || back_len == 10) {
        handleFilterReset(column);
      }
    }
  };
  const handleSearchDate = (column, value) => {
    if(value !== null && value !== undefined && value !== '') {
      if(value.length < 10){
        return false;
      }
    }
    setDateValues(prevState => ({
      ...prevState,
      [column]: value,
    }));
    setSearchTerms((prevSearchTerms) => {
      const newSearchTerms = { ...prevSearchTerms, [column]: value };
      setCurrentPage(1);
      const allSearchValues = Object.entries(newSearchTerms).map(([col, filterValue]) => {
        let columnName = col;
        let secondSearch = false;
        if (col.includes("_second")) {
          columnName = col.replace("_second", "");
          secondSearch = true;
        }
        let modifiedFilterValue = filterValue;
        
        if (filters[columnName].type === 'ListValue' && filterValue === 'All') {
          modifiedFilterValue = '';
        }
        return {
          filter: filters[columnName].type == 'between' ? (secondSearch != true ? "GreaterThanOrEqual" : "LessThanOrEqual" ) : filters[columnName].type,
          filterValue:modifiedFilterValue,

          filterColumn: columnName,
        };
      });
      onSearch(allSearchValues);
      return newSearchTerms;
    });
  };

  const handleFilterChange = (column, filterType) => {
    setFilters({ ...filters, [column]: { type: filterType, text: searchTerms[column] } });
    if(!searchTerms[column]) {
      return ;
    }
    setTextValues(prevState => {
      // Check if the key column+"_second" exists in prevState
      if (prevState.hasOwnProperty(column + "_second")) {
        // If the key exists, update the state to empty the value
        return {
          ...prevState,
          [column+"_second"]: ''
        };
      } else {
        // If the key doesn't exist, return the previous state without making any changes
        return prevState;
      }
    });
    setDateValues(prevState => {
      // Check if the key column+"_second" exists in prevState
      if (prevState.hasOwnProperty(column + "_second")) {
        // If the key exists, update the state to empty the value
        return {
          ...prevState,
          [column+"_second"]: ''
        };
      } else {
        // If the key doesn't exist, return the previous state without making any changes
        return prevState;
      }
    });
    setCurrentPage(1);
    const allSearchValues = Object.entries(searchTerms).map(([col, filterValue]) => {
      let columnName = col;
      let secondSearch = false;
      if (col.includes("_second")) {
        columnName = col.replace("_second", "");
        secondSearch = true;
      }
      let modifiedFilterValue = filterValue;
      if (filters[columnName].type === 'ListValue' && filterValue === 'All') {
        modifiedFilterValue = '';
      }
      return {
        filter: filters[columnName].type == 'between' ? (secondSearch != true ? "GreaterThanOrEqual" : "LessThanOrEqual" ) : filters[columnName].type,
        filterValue:modifiedFilterValue,
        filterColumn: columnName,
      };
    });
    onSearch(allSearchValues);
  };

  const handleFilterReset = (columnObject) => {
    let column = columnObject.fieldName;
    if (columnObject.fieldType.displayType == "Date" || columnObject.fieldType.displayType == "DateTime") {
      setDateValues(prevState => ({
        ...prevState,
        [column]: '',
        [column+"_second"]: '',
      }));
    }
    if (columnObject.fieldType.displayType == "Text" || columnObject.fieldType.displayType == "Email" || columnObject.fieldType.displayType == "Value" || columnObject.fieldType.displayType == "Currency" || columnObject.fieldType.displayType == "Phone") {
      setTextValues(prevState => ({
        ...prevState,
        [column]: '',
        [column+"_second"]: '',
      }));
    }
    setSearchTerms((prevSearchTerms) => {
      const updatedSearchTerms = { ...prevSearchTerms };
      if (updatedSearchTerms.hasOwnProperty(column + "_second")) {
        delete updatedSearchTerms[column+"_second"];
      }
      delete updatedSearchTerms[column];
      return updatedSearchTerms;
    });
    setCurrentPage(1);
    const allSearchValues = Object.entries(searchTerms).map(([col, filterValue]) => {
      let columnName = col;
      let secondSearch = false;
      if (col.includes("_second")) {
        columnName = col.replace("_second", "");
        secondSearch = true;
      }
      let modifiedFilterValue = filterValue;
      if (filters[columnName].type === 'ListValue' && filterValue === 'All') {
        modifiedFilterValue = '';
      }
      return {
        filter: filters[columnName].type == 'between' ? (secondSearch != true ? "GreaterThanOrEqual" : "LessThanOrEqual" ) : filters[columnName].type,
        filterValue:modifiedFilterValue,

        filterColumn: columnName,
      };
    }).filter(({ filterColumn }) => filterColumn !== column);
    onSearch(allSearchValues);
  };

  const openUrl = (url) => {
    window.open(url, '_blank');
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="scrollable-table-container">
        <MDBTable className="table table-hover">
          <MDBTableHead className="table-heading">
            <tr>
              {data.columns.map((column) => (
                (cookieVal && selectedColumns.includes(column.fieldName)) || !cookieVal ? (
                    column.visible === "Yes" && (
                        <th key={column.fieldName} scope="col" style={{ minWidth: column.width }}>
                            {column.sortable ? (
                                <span onClick={() => handleSort(column.fieldName)}>
                                    {translations[column.caption] != undefined ? translations[column.caption] : column.caption}
                                    &nbsp;
                                    {sortDirections[column.fieldName] === 'asc' ? <MDBIcon fas icon="arrow-up" /> : <MDBIcon fas icon="arrow-down" />}
                                </span>
                            ) : (
                                <span>{translations[column.caption] != undefined ? translations[column.caption] : column.caption}</span>
                            )}
                        </th>
                    )
                ) : null
            ))}

            </tr>

            <tr>
              {search == true && 
              (data.columns.map((column) => (
                (cookieVal && selectedColumns.includes(column.fieldName)) || !cookieVal ? (
                  column.visible == "Yes" && (
                  <td key={column.fieldName}>
                    <div style={{ display: 'flex', alignItems: 'center', width: 'max-content' }}>
                      {column.filter?.filterType != null ? (
                        <>
                          {(column.fieldType?.displayType == 'Date' || column.fieldType?.displayType == 'DateTime') ? (
                            <>
                            <MDBDatepicker value={dateValues[column.fieldName] || ''} name={column.fieldName} inputLabel={filters[column.fieldName]?.type == "between" ? "Min Date": "Select Date"} onChange={(value) => {
                              if (value !== null && value !== undefined && value !== '') {
                                handleSearchDate(column.fieldName, value);
                              }
                            }} className="date-picker search-date-picker" style={{ width: '90px' }} inline format='mm/dd/yyyy' disabled={false} onKeyPress={(ev)=>dateOnKeyPress(ev,column)}  onKeyDown={(evt)=>dateOnKeyDown(evt,column)} placeholder='mm/dd/yyyy'/>

                            {filters[column.fieldName]?.type == "between" &&
                              <MDBDatepicker value={dateValues[column.fieldName+'_second'] || ''} name={column.fieldName+'_second'} inputLabel={filters[column.fieldName]?.type == "between" ? "Max Date": ""} onChange={(value) => {
                                if (value !== null && value !== undefined && value !== '') {
                                  handleSearchDate(column.fieldName+'_second', value);
                                }
                              }} className="date-picker search-date-picker" style={{ width: '90px', marginLeft:'10px' }} inline format='mm/dd/yyyy' disabled={false} onKeyPress={(ev)=>dateOnKeyPress(ev,column)}  onKeyDown={(evt)=>dateOnKeyDown(evt,column)}placeholder='mm/dd/yyyy'/>
                            }
                            </>
                          ) : column.fieldType?.displayType == 'DateTime' ? (
                            <CustomDateRangePicker fieldName={column.fieldName} resetDateRange={resetDateRange} onDatesChange={handleDatesChange} />
                          ) : column.filter.filterType == 'List' ? (
                            <MDBDropdown>
                              <MDBDropdownToggle tag='a' className='btn btn-secondary' style={{ width: '100px' }}>
                                {searchTerms[column.fieldName] || column.filter?.defaultValue}
                              </MDBDropdownToggle>
                              <MDBDropdownMenu>
                                {column.filter?.filterValues.map((item, index) => (
                                  <MDBDropdownItem key={index} link onClick={() => handleSearchDropDown(item.value, column.fieldName)}>
                                    {item.caption}
                                  </MDBDropdownItem>
                                ))}
                              </MDBDropdownMenu>
                            </MDBDropdown>
                          ) : (
                            <>
                            <InputField
                              type="text"
                              label={filters[column.fieldName]?.type == "between" ? "Min Value": " "}
                              value={
                                textValues[column.fieldName] || ""
                              }                            
                              onChange={(event) => handleSearch(event, column.fieldName, column.fieldType.displayType)}
                              style={{ width: '90px' }}
                            />
                            {filters[column.fieldName]?.type == "between" &&
                            <>
                            <div style={{width:'1.5rem'}}></div>
                            <InputField
                              type="text"
                              label={filters[column.fieldName]?.type == "between" ? "Max Value": ""}
                              value={
                                textValues[column.fieldName+"_second"] || ""
                              }                            
                              onChange={(event) => handleSearch(event, column.fieldName+"_second", column.fieldType.displayType)}
                              style={{ width: '90px' }}
                            />
                            </>
                            }
                            </>
                          )}
                          {column.filter?.filterType !== 'List' && <MDBDropdown>
                            <MDBDropdownToggle tag="a" style={{ paddingLeft: '10px' }}>
                              <MDBIcon fas icon="filter" className="filter-icon" />
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                              {column.filter.filterType === 'Text' ?
                                FILTER_OPTIONS_TEXT.map((option) => (
                                  <MDBDropdownItem
                                    link
                                    key={option.value}
                                    onClick={() => handleFilterChange(column.fieldName, option.value)}
                                    className={(filters[column.fieldName] && option.value === filters[column.fieldName].type) ? 'active' : ''}
                                  >
                                    {option.text}
                                  </MDBDropdownItem>
                                ))
                                :
                                FILTER_OPTIONS_VALUE.map((option) => (
                                  <MDBDropdownItem
                                    link
                                    key={option.value}
                                    onClick={() => handleFilterChange(column.fieldName, option.value)}
                                    className={(filters[column.fieldName] && option.value === filters[column.fieldName].type) ? 'active' : ''}
                                  >
                                    {option.text}
                                  </MDBDropdownItem>
                                ))
                              }
                            </MDBDropdownMenu>
                          </MDBDropdown>}
                          {(searchTerms[column.fieldName] != undefined || searchTerms[column.fieldName+"_second"] != undefined) && <div key={column.fieldName} onClick={() => handleFilterReset(column)} style={{ cursor: 'pointer', marginTop: '2px', marginLeft: '4px' }}>
                            <i className="fas fa-filter-circle-xmark"></i>
                          </div>}
                        </>
                      ) : null}
                    </div>
                  </td>
                  )
                ) : null
              )))}
            </tr>
          </MDBTableHead>

          <MDBTableBody>
            {data.columns.length != 0 && data.rows.length === 0 ? (
              <tr>
                <td colSpan={data.columns.length}>No data found</td>
              </tr>
            ) : (
              data.rows.map((item, index) => (
                <tr key={index}>
                  {data.columns.map((column) => (
                    (cookieVal && selectedColumns.includes(column.fieldName)) || !cookieVal ? (
                    column.visible == "Yes" && (
                    <td key={column.fieldName} style={{ width: '150px' }}> 
                      {(column.fieldName === 'loginAttemptCount' && parseInt(item.loginAttemptCount) >= 6 && 
                       item.lastLoginAttempt && isWithinLastHour(item.lastLoginAttempt) && portal === "user") ? (
                        <MDBIcon fas icon="user-lock"/>
                      ) : column.fieldType?.displayType === 'DateTime' 
                        ? formatDateTime(item[column.fieldName]) 
                        : ( column.fieldType?.displayType === 'Date' 
                          ? formatDate(item[column.fieldName]) 
                          : (column.fieldType?.displayType === 'Text' 
                            ? splitStringByLength(item[column.fieldName]) 
                            : (column.fieldType?.displayType === 'Email' 
                              // ? <a href={`mailto:${item[column.fieldName]}`}>{item[column.fieldName]}</a>
                                ? splitStringByLength(item[column.fieldName]) 
                                : (column.fieldType?.displayType === 'Phone' 
                                ? <a href={`tel:${item[column.fieldName]}`} style={{textDecoration:'underline'}}>{item[column.fieldName]}</a>
                                : (column.fieldType?.displayType === 'URL' 
                                ? <button onClick={() => openUrl(item[column.fieldName])} className='ripple ripple-surface ripple-surface-light btn btn-secondary' >View</button>
                                : (column.fieldType?.displayType === 'Currency' 
                                  ? <p style={{textAlign:'right'}}>{formatCurrency(item[column.fieldName])}</p>
                                  : item[column.fieldName]
                                  )
                                )
                              )
                            )
                          )
                        )
                      }
                    </td>
                    )
                  ) : null
                  ))}
                </tr>
              ))
            )}
          </MDBTableBody>
        </MDBTable>
      </div>
      {data.rows.length > 0 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} onRowsPerPageChange={handleRowsPerPageChange} 
      itemsPerPage={rowsPerPage} />}
    </div>
  );
};

export default DataTable;
